import { withTranslations } from '@/utils/Language';
import clientsEn from '@/assets/i18n/clients/en.json';
import propertiesEn from '@/assets/i18n/properties/en.json';
import tagsEn from '@/assets/i18n/tags/en.json';
import uiEn from '@/assets/i18n/ui/en.json';
import languagesEn from '@/assets/i18n/languages/default.json';
import languagesTranslatedEn from '@/assets/i18n/languages_translated/en.json';

const enDefault = { ...clientsEn, ...propertiesEn, ...tagsEn, ...uiEn, ...languagesEn, ...languagesTranslatedEn };

export default withTranslations(
  (lang) =>
    Promise.all([
      import(`@/assets/i18n/clients/${lang}.json`),
      import(`@/assets/i18n/properties/${lang}.json`),
      import(`@/assets/i18n/tags/${lang}.json`),
      import(`@/assets/i18n/ui/${lang}.json`),
      import('@/assets/i18n/languages/default.json'),
      import(`@/assets/i18n/languages_translated/${lang}.json`)
    ]).then(([clients, properties, tags, ui, languages, languagesTranslated]) => ({
      ...clients.default,
      ...properties.default,
      ...tags.default,
      ...ui.default,
      ...languages.default,
      ...languagesTranslated.default
    })),
  enDefault
);
